import { useState } from 'react'

const ImageWithRetry = (props) => {
  const { notFoundSrc, src, ...imageAttributes } = props;
  const [key, setKey] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const maxAttempts = 5;
  const retryDelay = 5000; // 5 seconds

  const handleImageError = (e) => {
    try {
      //Primero asigno a la imagen el valor de la propiedad notFoundSrc, es una imagen default
      e.target.src = notFoundSrc;

      //Si la imagen no pudo cargarse, se vuelve a intentar por 5 ocasiones con un delay de 5 segundos
      if (attempts < maxAttempts) {
        console.error(`Image failed to load. Attempt ${attempts + 1} of ${maxAttempts}. Retrying in 5 seconds... ${src}`);

        setTimeout(() => {
          setAttempts(prevAttempts => prevAttempts + 1);
          setKey(prevKey => prevKey + 1);
        }, retryDelay);

      } else {
        console.error(`Max retry attempts reached. Giving up on loading the image. ${src}`);
      }
    } catch (error) {
      console.error(`Error at handleImageError: ${error} ${src}`);
    }
  }

  return (
    <img
      alt=""
      {...imageAttributes}
      key={key}
      src={src || notFoundSrc}
      onError={handleImageError}
    />
  )
}
export default ImageWithRetry;
